import { Component, OnInit, ViewChild } from '@angular/core';
import { UserService } from 'src/app/services/user-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { MatPaginator, MatSort, MatTableDataSource } from "@angular/material";
import { environment } from 'src/environments/environment';
declare var $: any;

@Component({
  selector: 'smart-manage-user',
  templateUrl: './manage-user.component.html',
  styleUrls: ['./manage-user.component.css', '../platform-color/platform-color.css']
})
export class ManageUserComponent implements OnInit {

  pageShow = "viewall";
  opA = "adduser";
  opE = "authorize";
  limit: number = 5;
  page: number = 1;
  total: any;
  URLUPLOAD: any = environment.URLUPLOAD;
  AllUser: any;
  UserInfo: any;
  authorize: any;
  ChildOrgList: any = [];
  displayedColumns: string[] = ['ผู้ใช้งาน', 'จัดการ'];
  dataSource = new MatTableDataSource();
  userIdToDelete = null
  // @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  search: string = "";
  constructor(
    private UserService: UserService,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.getUserData("");
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public async getUserData(status) {
    this.spinner.show();
    this.page = 1
    this.dataSource.data = [];
    let AllUserData = [];
    this.UserService.getUserdata(status)
      .subscribe(async (success) => {

        if (success.code == 200) {
          this.AllUser = success.data;
          for (let i = 0; i < this.AllUser.length; i++) {
            const element = this.AllUser[i];
            let org_id = sessionStorage.getItem('Org')
            let child_org_id = sessionStorage.getItem('ChildOrg')
            let active = false;
            await element.authorized.filter(async function (value) {
              if (value.org_id == org_id) {
                await value.child_orgs.filter(function (value2) {
                  if (value2.child_org_id == child_org_id) {
                    active = value2.active
                  }
                });
              }
            });
            AllUserData.push({
              username: element.username,
              first_name: element.first_name,
              last_name: element.last_name,
              profile_img: element.profile_img,
              id: element.id,
              active: active,
              farms: element.farm
              // farms: element.farm
              // system_role: element.authorized[0].child_orgs[0].farms[0].role,
            })
          }
          this.spinner.hide();
          this.dataSource.data = AllUserData;
          this.dataSource.sort = this.sort;
          // this.dataSource.paginator = this.paginator;
        } else {
          this.dataSource.data = [];
          this.spinner.hide();
        }

      });
  }

  backToMain() {
    this.pageShow = "viewall";
  }

  async viewUserinfo(id) {
    this.pageShow = "userinfo";
    this.spinner.show()
    setTimeout(async () => {
      this.UserService.getUserByid(id)
        .subscribe(async (success) => {
          if (success.code == 200) {
            this.UserInfo = success.data;
            let org_id = sessionStorage.getItem('Org')
            let child_org_id = sessionStorage.getItem('ChildOrg')
            let farmArr;
            // this.authorize = this.UserInfo.authorized.filter()
            let active = false
            await this.UserInfo.authorized.filter(async function (value) {
              if (value.org_id == org_id) {
                await value.child_orgs.filter(function (value2) {
                  if (value2.child_org_id == child_org_id) {
    
                    farmArr = value2.farms
                    active = value2.active
                  }
                });

              }

            });
            Object.assign(this.UserInfo, {
              child_active: active
            })
            this.createFarmPermiss(farmArr)
            // this.authorize = farmArr;
            this.spinner.hide()
            // $('#addAuthSuccessmodal').modal('show');
          } else {
            // $('#addAuthFailmodal').modal('show');
            this.spinner.hide()
          }
        });

    }, 100);
  }

  async showDialogDeleteUser(id: string) {
    if (!id) return
    this.userIdToDelete = id
    $('#confirmDeleteUser').modal('show');

    /*   await this.UserService.deleteUser(id).subscribe(async(sucess) => {
        if(sucess.code == 200){
          console.log("Deleted")
        }else{
          console.log("Delete Error")
        }
      }) */
  }


  async deleteUser() {
    $('#confirmDeleteUser').modal('hide');
    if (!this.userIdToDelete) return
    this.UserService.deleteUser(this.userIdToDelete).subscribe(async (sucess) => {
      if (sucess.code == 200) {
        $('#successDeleteUser').modal('show');
      } else {
        $('#errorDeleteUser').modal('show');
      }
    })
  }
  
  async createFarmPermiss(farms = []){
    let completedFarm = []
    if (this.UserInfo) {
      for(let i = 0; i < farms.length ; i++){
        let farm = this.UserInfo.farm.find(x => x._id == farms[i].farm_id)
        if(farm){
          completedFarm.push({
            _id: farm._id,
            role: this.getRoleName(farms[i].role) ,
            name : farm.name
          })
        }
      }
    };
    this.authorize = completedFarm;
  }

  getFarmName(farmId) {

    let farm = this.UserInfo.farm.filter(x => x._id == farmId)
    return farm[0].name ? farm[0].name : '-'
  }
  getRoleName(role) {
    if (role == 'farm_manager') {
      return 'Farm manager'
    } else if (role == 'worker') {
      return 'Worker'
    } else if (role == 'viewer') {
      return 'Viewer'
    } else {
      return role
    }
  }

  getPages(pageNo) {
    this.page = pageNo
    // this.page = pageNo.pageIndex+1;
  }

  resetPage() {
    this.page = 1
  }
}
